import { render, staticRenderFns } from "./FullScreenLayout.vue?vue&type=template&id=2ffa5a4e&"
import script from "./FullScreenLayout.vue?vue&type=script&lang=ts&"
export * from "./FullScreenLayout.vue?vue&type=script&lang=ts&"
import style0 from "./FullScreenLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VContainer,VMain})
